import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../api";

const AuthContext = createContext(null);
const RANK = { viewer: 0, editor: 1, admin: 2 };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => api.me().then(setUser).catch(() => setUser(null)).finally(() => setLoading(false)), []);
  useEffect(() => {
    refresh();
    const expired = () => setUser(null);
    window.addEventListener("auth:expired", expired);
    return () => window.removeEventListener("auth:expired", expired);
  }, [refresh]);

  const value = {
    user,
    loading,
    login: async (email, password) => setUser(await api.login(email, password)),
    register: async (body) => setUser(await api.register(body)),
    logout: async () => { await api.logout().catch(() => {}); setUser(null); },
    can: (role) => !!user && RANK[user.role] >= RANK[role],
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
